import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Wrapper } from "../../../../Wrapper";
import { Stream, TitleGreen, Description } from "../../styled";
import { desktop } from "../../../../../theme";
import image1 from "./2/image1.gif";
import image5 from "./2/image5.gif";
import image6 from "./2/image6.gif";
import image7 from "./2/image7.gif";
import image10 from "./2/image10.gif";
import image12 from "./2/image12.gif";
import sun from "./2/sun.svg";
import android from "./2/android.svg";
import flower from "./2/flower.svg";

const TitleStyled = styled(TitleGreen)(
  css({
    mt: 0,
    mb: [85, 150],
  })
);

const Gif = styled("img")(
  css({
    display: "block",
    width: "100%",
    borderRadius: 8,
  })
);

const Content = styled("div")(
  css({
    flexGrow: 1,
  })
);

const Decor = styled("div")(
  css({
    position: "relative",
    width: [null, 330],
    minWidth: [250, 330],
    maxWidth: 400,
    ml: ["auto", 80],
    mr: ["auto", 0],
    mt: [45, 0],
    order: [null, 2],
    flexGrow: 10,
  })
);

const DecorSquare = styled(Decor)(
  css({
    maxWidth: [250, "auto"],
  })
);

const DecorCentered = styled("div")(
  css({
    alignSelf: "center",
  })
);

const DecorBottom = styled("div")(
  css({
    [Gif]: {
      [desktop]: {
        position: "absolute",
        top: "130%",
      },
    },
  })
);

const Layout = styled("div")(
  css({
    display: [null, "flex"],
    mb: 50,
    alignItems: "stretch",
  })
);

const Subtitle = styled("div")(
  css({
    fontWeight: "bold",
    fontSize: [2, 4],
    mb: [30, 36],
  })
);

const DecorSvg = styled("img")(
  css({
    display: ["none", "block"],
    position: "absolute",
    transform: "translate(-50%, -50%)",
    zIndex: -1,
  })
);

const Sun = styled(DecorSvg)(
  css({
    top: 0,
    left: "50%",
    zIndex: 1,
  })
);

Sun.defaultProps = {
  src: sun,
};

const Flower = styled(DecorSvg)(
  css({
    left: "100%",
    top: "50%",
  })
);
Flower.defaultProps = {
  src: flower,
};

const Android = styled(DecorSvg)(
  css({
    top: "90%",
    left: "50%",
  })
);
Android.defaultProps = {
  src: android,
};

const StreamStyled = styled(Stream)(
  css({
    pb: [null, 350],
  })
);

const Description4 = styled(Description)(
  css({
    maxWidth: 705,
  })
);

const Description5 = styled(Description)(
  css({
    maxWidth: 670,
  })
);

const Description6 = styled(Description)(
  css({
    maxWidth: 575,
  })
);

export const WhatsDo = () => (
  <StreamStyled id="whats-do">
    <Wrapper>
      <TitleStyled>Что в tiktok можно делать?</TitleStyled>
      <Layout>
        <Content>
          <Description>
            Нет чётких границ. В&nbsp;этом и&nbsp;кайф TikTok&rsquo;а. Пути
            алгоритмов этого приложения неисповедимы. Неоднократно в&nbsp;тренды
            попадали ролики аккаунтов с&nbsp;минимальным количеством
            подписчиков. О&nbsp;чём это говорит? Правильно! Шанс сделать
            популярным свой TikTok есть у&nbsp;каждого! Что&nbsp;же можно делать
            в&nbsp;этой социальной сети? Пойдём от&nbsp;простого
            к&nbsp;сложному.
          </Description>
        </Content>
        <Decor>
          <Gif src={image1} />
        </Decor>
      </Layout>
      <Layout>
        <Content>
          <Subtitle>1. Снимайте тренды</Subtitle>
          <Description>
            Мы&nbsp;заметили, что много просмотров в&nbsp;TikTok
            набирают&nbsp;те, кто вовремя снял тренд. Поэтому, если
            ты&nbsp;приметил тренд, который становится популярным,
            то&nbsp;скорее снимай его и&nbsp;выкладывай, через неделю
            он&nbsp;может быть уже не&nbsp;актуальным. Отслеживать тренды
            придётся тебе, наш юный друг! Бумеры в&nbsp;этом мало секут.
            Но&nbsp;это пока! Кстати, ничего, что мы&nbsp;тебя так называем?
          </Description>
        </Content>
        <DecorSquare>
          <Gif src={image5} />
        </DecorSquare>
      </Layout>
      <Layout>
        <Content>
          <Subtitle>
            2. Снимайте видосы с&nbsp;эффектом случайно снятого видео
          </Subtitle>
          <Description>
            Очень часто вирусными видео становятся&nbsp;те, которые сняты
            &laquo;якобы&raquo; случайно. В&nbsp;общей массе выделяются пранки.
            Зрителю кажется, что герой на&nbsp;самом деле импровизирует
            в&nbsp;ситуации.
          </Description>
          <Description>
            На&nbsp;самом деле сюжет пранков идёт по&nbsp;чёткому плану
            и&nbsp;сценарию, а&nbsp;потом ещё, используя монтаж, выбираются
            лучшие моменты. Пранкуйте друг друга дома, друзей или соседей
            по&nbsp;даче. Вы&nbsp;получите массу эмоций! Придумайте пранк для
            отца и&nbsp;вместе с&nbsp;мамой подложите ему не&nbsp;пену для
            бритья, а&nbsp;сливки. Предложите отцу пранкануть тёщу.
            Он&nbsp;согласится, даже не&nbsp;дослушав до&nbsp;конца вашу идею.
            Пропишите для себя идеальный пранк и&nbsp;снимите
            &laquo;пробник&raquo;. Поняв все подводные камни, начинайте
            контентить.
          </Description>
        </Content>
        <Decor as={DecorCentered}>
          <Gif src={image10} />
        </Decor>
      </Layout>
      <Layout>
        <Content>
          <Subtitle>3. Снимайте пародии</Subtitle>
          <Description>
            Снимай крутые дуэты и&nbsp;отмечай известных блогеров&nbsp;&mdash;
            это хорошо заходит в&nbsp;рекомендации и&nbsp;на&nbsp;них обращают
            внимание авторы первоначального ролика. Например, Эльдар Джарахов
            часто делает взаимные дуэты со&nbsp;своими подписчиками, которые
            нарисовали его портрет или сделали татуировку со&nbsp;строками
            из&nbsp;его песни.
          </Description>
        </Content>
        <DecorSquare>
          <Gif src={image12} />
        </DecorSquare>
      </Layout>
      <Layout>
        <Content>
          <Subtitle>4. Придумайте свою фишку для видеороликов</Subtitle>
          <Description4>
            Не&nbsp;забывай, что аудитория должна тебя запомнить. Для этого
            нужно придумать себе фишки, которые ты&nbsp;будешь использовать. Это
            может быть необычный монтаж, рубрики или яркие детали в&nbsp;образе
            (косы, шапка, очки, макияж). Очень часто родителей просят придумать
            костюм для своих детей на&nbsp;школьные тусовки.
          </Description4>
          <Description4>Тут два варианта.</Description4>
          <Description4>
            Расчехляй гардероб или применяй эти навыки там, где это реально
            необходимо. Немало важной фишкой является фон, на&nbsp;котором
            ты&nbsp;снимаешь контент. Чаще всего это стена&nbsp;&mdash; это
            скучно. Таких миллиарды. Попробуй поставить штатив в&nbsp;угол
            комнаты. Так в&nbsp;кадре появится больше &laquo;воздуха&raquo;.
            Аудитория Тик Тока любит правдивость, а&nbsp;с&nbsp;помощью этого
            лайфхака ты&nbsp;покажешь личное пространство.
          </Description4>
        </Content>
        <Decor>
          <Gif src={image7} />
        </Decor>
      </Layout>

      <Layout>
        <Content>
          <Subtitle>5. Монтаж</Subtitle>
          <Description5>
            Если твоё видео состоит из&nbsp;нескольких фрагментов, то&nbsp;для
            простого видеомонтажа ты&nbsp;можешь использовать редактор Canva.
            А&nbsp;для более сложного монтажа используй приложение Videoleap,
            в&nbsp;нём много эффектов для создания очень необычных переходов.
            Для вдохновения смотри тиктоки Насти Ивлеевой с&nbsp;крутыми
            переходами.
          </Description5>
          <Description5>
            Проведите креативную сессию на&nbsp;кухне. Почему там? Потому что
            все важные переговоры в&nbsp;семье ведутся именно там. Обсудите, кто
            лучше сечёт в&nbsp;монтаже. Вангуем, что это&nbsp;ты!
          </Description5>
        </Content>
        <DecorSquare as={DecorBottom}>
          <Sun />
          <Gif src={image6} />
        </DecorSquare>
      </Layout>

      <Layout>
        <Content>
          <Subtitle>6. Постинг</Subtitle>
          <Description6>
            Когда первый TikTok будет готов к&nbsp;постингу, не&nbsp;сомневайся!
            Пробуй себя! На&nbsp;любой случай блогерской жизни всегда существует
            кнопка &laquo;DELETE&raquo;! Не&nbsp;стоит агриться из-за лайтового
            буллинга дноклов или думеров. Подождём минуту, чтобы родители
            перевели это предложение, а&nbsp;ты&nbsp;пока можешь орнуть
            с&nbsp;этого...
          </Description6>
          <Description>…</Description>
          <Description>…</Description>
          <Description>…</Description>
          <Description>…</Description>
          <Description>…</Description>
          <Description>…</Description>
          <Description>Перевели? Продолжим.</Description>
        </Content>
        <Decor>
          <Flower />
          <Android />
        </Decor>
      </Layout>
    </Wrapper>
  </StreamStyled>
);
